// Elements whose text content is more than whitespace once trimmed.
const getTextNodes = (nodes: NodeList) =>
	Array.from(nodes).filter((node) => {
		const textContent = node.textContent || '';
		return textContent.trim().length > 0;
	});

/**
 * Returns true when the message would render visible text
 *
 * SSR note: `DOMParser` is browser-only and is not polyfilled in Confluence's SSR runtime. We guard
 * the exact API (`typeof DOMParser === 'undefined'`) rather than `typeof window`, because in
 * Confluence bundles `window` is replaced at bundle time and always exists, so it is not a valid SSR
 * signal. On the server this returns false and the real verdict is computed on the client after
 * hydration.
 */
export const hasVisibleWelcomeMessageContent = (messageHtml?: string | null): boolean => {
	if (!messageHtml || typeof DOMParser === 'undefined') {
		return false;
	}

	const domParser = new DOMParser();
	const dom = domParser.parseFromString(messageHtml, 'text/html');
	const allTags = dom.querySelectorAll('*');

	return getTextNodes(allTags).length > 0;
};
